import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { AlmondHullSplitSettingsModal } from './AlmondHullSplitSettingsModal'

const hullSplitSettingsSetPermission = 'EDIT_ALMOND_HULL_SPLIT_VALUES_FOR_STATIONS'

export const AlmondHullSplitSettingsTitleLink = () => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: hullSplitSettingsSetPermission })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              almondHullSplitSettingOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Hull Split Settings')}
      </ResponsiveMenuItem>
      <AlmondHullSplitSettingsModal data-role="modal" />
    </>,
  )

  return titleLink
}
